import api from '../api'
import env from '../env'
import { dom, human } from './utils-js'

function exportAllSession(vm) {
  api.hifs.getDirRecursiveData(env.sess.basePath, (error, data, response) => {
    if (error) {
      api.errHandler(vm, error, response)
    } else {
      dom.downloadBlob(`exported-${human.shortTime(new Date())}.watsess`, JSON.stringify(data))
    }
  })
}

export default {
  exportAllSession,
}